<template>
	<section
		class="full_width_banner"
		:style="{'--progress': 0}"
	>
		<div class="container">
			<div class='left'>
				<h4
					:data-highlightword="getWordsInFirstRow(title)"
					v-html="title"
				></h4>
			</div>
			<div class='right'>
				<div
					class="description"
					v-html="description"
				></div>

				<primary-button
					:class='cta_theme_colour'
					v-if="parsedCta"
					:label="parsedCta.title"
					:link="parsedCta"
				></primary-button>
			</div>

		</div>

	</section>
</template>

<script>
import PrimaryButton from '../vue/PrimaryButton.vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			scrollOpacity: 1,
		};
	},

	props: {
		title: {},
		description: {},
		call_to_action: {},
		cta_theme_colour: {},
	},

	computed: {
		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},

		calculateOpacity() {
			return () => {
				const element = document.querySelector('.scroll-element');
				if (!element) return;

				const elementRect = element.getBoundingClientRect();
				const viewportHeight = window.innerHeight;

				// Calculate distance of element from top of viewport
				const distanceFromTop = Math.max(0, elementRect.top);
				// Calculate maximum distance the element can travel
				const maxDistance = viewportHeight + elementRect.height;

				// Calculate opacity based on scroll position
				this.scrollOpacity = 1 - distanceFromTop / maxDistance;
			};
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		getWordsInFirstRow(paragraph) {
			const words = paragraph.trim().split(' ');

			const firstRowWords = [];
			const tempElement = document.createElement('span');
			document.body.appendChild(tempElement);

			for (const word of words) {
				tempElement.textContent = `${firstRowWords.join(' ')} ${word}`;

				if (tempElement.offsetTop !== firstRowWords.length) {
					break;
				}

				firstRowWords.push(word);
			}

			document.body.removeChild(tempElement);

			return firstRowWords;
		},
	},

	components: {
		PrimaryButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
		window.addEventListener('scroll', this.calculateOpacity);

		const eachPanel = this.$el;
		ScrollTrigger.create({
			trigger: eachPanel,
			start: 'top center',
			end: '+=2000',
			onUpdate: (self) => {
				let progressValue = self.progress.toFixed(5);
				self.trigger.style.setProperty('--progress', progressValue);
			},
		});
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.calculateOpacity);
	},
};
</script>


<style lang="scss" scoped>
@import '../../styles/common/variables';

.full_width_banner {
	background: var(--background-colour);
	position: relative;
	overflow: hidden;
	border-top: 1px solid var(--light-grey);
	--progress: 0;

	.container {
		padding-top: 75px;
		padding-bottom: 75px;
		padding-left: 0;
		padding-right: 0;
		gap: 0;

		@media (max-width: $mobile-xl) {
			padding-top: 50px;
			padding-bottom: 50px;
			row-gap: 24px;
		}

		.left {
			grid-column: span 4;
			padding-left: 40px;

			h4 {
				color: var(--text-colour);
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				padding-left: 24px;
			}
		}

		.right {
			grid-column: 5 / span 7;
			padding-left: 150px;

			@media (max-width: $tablet) {
				padding-left: 50px;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				padding-left: 24px;
			}

			.description {
				&::v-deep {
					p {
						font-size: 24px;
						line-height: 30px;
						font-weight: 300;
						color: var(--text-colour);

						&:first-of-type {
							margin-top: 0;
						}

						&:last-of-type {
							margin-bottom: 0;
						}

						a {
							font-size: 24px;
							line-height: 30px;
							font-weight: 300;
							color: var(--duco-blue);
							text-decoration: none;

							&::after {
								content: '\2192';
								margin-left: 5px;
							}
						}
					}
				}

				a {
					font-size: 24px;
					line-height: 30px;
					font-weight: 300;
					color: var(--duco-blue);
				}
			}

			.site_button {
				margin-top: 30px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FullWidthBanner.vue